module.exports = __webpack_public_path__ + "img/pointC_mark2.cae6f1a9.png";